import $ from 'jquery';

export default function () {

    $('#js-open-tbg-screen-1').on('click', function(e) {
        e.preventDefault();

        $('.js-open-tbg-screen').addClass('is-active');
        $('.js-side-menu-bar').addClass('is-active');

        setTimeout(function() {
            location.href = $('#js-open-tbg-screen-1').attr('href');
        }, 1500);

    });

    $('#js-open-tbg-screen-2').on('click', function(e) {
        e.preventDefault();

        $('.js-open-tbg-screen').addClass('is-active');
        $('.js-side-menu-bar').addClass('is-active');

        setTimeout(function() {
            location.href = $('#js-open-tbg-screen-2').attr('href');
        }, 1500);

    });

    $('#js-open-tpc-pre-screen-1').on('click', function(e) {
        e.preventDefault();

        $('.js-open-tpc-screen').addClass('is-active');
        $('.js-side-menu-bar').addClass('is-active');

        setTimeout(function() {
            location.href = $('#js-open-tpc-pre-screen-1').attr('href');
        }, 1500);

    });

    $('#js-open-tpc-pre-screen-2').on('click', function(e) {
        e.preventDefault();

        $('.js-open-tpc-screen').addClass('is-active');
        $('.js-side-menu-bar').addClass('is-active');

        setTimeout(function() {
            location.href = $('#js-open-tpc-pre-screen-2').attr('href');
        }, 1500);

    });

    $(window).on('load', function() {
        setTimeout(function() {
            $('body').addClass('is-fade-in');
        }, 500);
    });

}
